import { createSlice } from "@reduxjs/toolkit";
import adminApi from "../../service/adminService";
const initialState = {
    user: null,
    tokenData: null
  };

const adminAuthenSlice = createSlice({
    name: 'adminAuthen',
    initialState,
    reducers:{
        updateAdminProfile(state, action) {
            console.log('redux updateAdminProfile ' + JSON.stringify(action.payload))
            state.user = (action.payload?.userData);
            state.tokenData = (action.payload.tokenData)
        },
        updateAccessToken(state, action) {
            state.tokenData = (action.payload)
            console.log('redux updateAccessToken ' + JSON.stringify(state))
        },
        clearAdminProfile() {
            return {
                ...initialState,
            };
        },
    },
    extraReducers:{}
})
export const { updateAdminProfile, clearAdminProfile,
    updateAccessToken
 } = adminAuthenSlice.actions 

export default adminAuthenSlice.reducer;